import { PROPOSAL_TOPIC_ENTITY_CLASS } from "documents/categories/document-category";
import type DocumentTopic from "documents/topics/document-topic";

/**
 * The records a document is filed under: its topics that name a proposal, a work agreement or a
 * proposal template, one each however many topics name it (#6720). A document is copied into a
 * proposal as one of its fields, so its topics are where its uses are written.
 */
const usageKinds = [
  { entityClasses: [PROPOSAL_TOPIC_ENTITY_CLASS, "Proposal"], one: "proposal", many: "proposals" },
  { entityClasses: ["Work.Agreement"], one: "work agreement", many: "work agreements" },
  { entityClasses: ["Work.ProposalTemplate", "Work.ClientProposalTemplate"], one: "proposal template", many: "proposal templates" },
] as const;

/** What a document is used in, as it reads in its Used in cell: "2 proposals, 1 work agreement". Undefined for none. */
export function documentUsagesText(topics: readonly DocumentTopic[]): string | undefined {
  const parts: string[] = [];
  for (const kind of usageKinds) {
    const ids = new Set(
      topics
        .filter((topic) => (kind.entityClasses as readonly string[]).includes(topic.entityClass ?? "") && topic.entityId)
        .map((topic) => topic.entityId!.value),
    );
    if (ids.size === 0) continue;
    parts.push(`${ids.size} ${ids.size === 1 ? kind.one : kind.many}`);
  }
  return parts.length ? parts.join(", ") : undefined;
}
